import React from "react";

import exclusionBuild from '../../../assets/images/icons/exclusion-build.svg'
import exclusionRiver from '../../../assets/images/icons/exclusion-river.svg'
import exclusionDeterioration from '../../../assets/images/icons/exclusion-deterioration.svg'

export const MAIN_EXCLUSIONS = [
    {
        id: 1,
        icon: "exclusion-build",
        image: exclusionBuild,
        content: (
            <>
                Si tu casa tiene más de
                <br /> 50 años
                <span /> de construido o <br />
                remodelado.
            </>
        ),
    },
    {
        id: 2,
        icon: "exclusion-river",
        image: exclusionRiver,
        content: (
            <>
                Si tu casa se ubica a<br /> menos de
                <span /> 500 metros de
                <br /> distancia de la
                <span /> orilla del
                <br /> mar, río o laguna.
            </>
        ),
    },
    {
        id: 3,
        icon: "exclusion-deterioration",
        image: exclusionDeterioration,
        content: (
            <>
                Deterioro gradual por
                <br /> el uso y/o
                <span /> tiempo del
                <br /> inmueble o bien.
            </>
        ),
    },
];
